import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { gtmEvent } from '@dtvgo/gtm-event-report';
import { TAGS_HASH_AND_EVENTS } from '../../utils/googleTags/tagsHashAndEvents';

const GtmLocalContext = createContext(undefined);

const contextDefaultValue = {
  miniEpgLiveTitle: undefined,
  pdpSelectedTabTitle: undefined,
  selectedSeason: undefined,
};

function GtmLocalProvider({ children, commonDimensionsData }) {
  const [state, setState] = useState(contextDefaultValue);

  const gtmChangeItem = useCallback((item) => {
    setState((prevState) => ({ ...prevState, ...item }));
  }, []);

  const commonTaggingEvent = useCallback(({
    category,
    subCategory,
    eventName,
    data = {},
  }) => {
    gtmEvent({
      hash: TAGS_HASH_AND_EVENTS[category][subCategory][eventName]?.hash,
      eventType: TAGS_HASH_AND_EVENTS[category][subCategory][eventName]?.event,
      dimensions: TAGS_HASH_AND_EVENTS[category][subCategory][eventName]?.dimensions,
      userData: commonDimensionsData,
      data,
    });
  }, [commonDimensionsData]);

  return (
    <GtmLocalContext.Provider
      value={useMemo(() => ({
        gtmState: state,
        gtmChangeItem,
        commonTaggingEvent,
      }), [state, gtmChangeItem, commonTaggingEvent])}
    >
      {children}
    </GtmLocalContext.Provider>
  );
}

export default GtmLocalProvider;
export const useGtmLocalContext = () => useContext(GtmLocalContext);
export { GtmLocalContext };

GtmLocalProvider.propTypes = {
  children: PropTypes.node.isRequired,
  commonDimensionsData: PropTypes.instanceOf(Object),
};

GtmLocalProvider.defaultProps = {
  commonDimensionsData: {},
};
